import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import DashboardLayout from './components/DashboardLayout';
import Dashboard from './pages/Dashboard';
import Managers from './pages/Managers';
import Members from './pages/Members';
import Payments from './pages/Payments';
import Revenue from './pages/Revenue';
import Logs from './pages/Logs';
import SystemHealth from './pages/SystemHealth';
import Settings from './pages/Settings';
import GroupChats from './pages/GroupChats';
import GroupChatDetail from './pages/GroupChatDetail';

const ProtectedRoute = ({ children }) => {
  const { admin, loading } = useAuth();
  if (loading) return <div style={{ color: '#fff', padding: 40 }}>Yükleniyor...</div>;
  return admin ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="managers" element={<Managers />} />
            <Route path="members" element={<Members />} />
            <Route path="payments" element={<Payments />} />
            <Route path="revenue" element={<Revenue />} />
            <Route path="logs" element={<Logs />} />
            <Route path="system" element={<SystemHealth />} />
            <Route path="settings" element={<Settings />} />
            <Route path="group-messages" element={<GroupChats />} />
            <Route path="group-messages/:chatId" element={<GroupChatDetail />} />
          </Route>
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;